// extracted by mini-css-extract-plugin
export default {"Placeholder":"placeholder_Placeholder__3vlpe","gradient":"placeholder_gradient__6pQt8"};